<template>
  <div class="sr-dialog-select">
    <template v-if="!getTextModel">
      <div
        class="dialog_select_input"
        @click="handleFocus"
        v-if="table.tableConfig.selectionConfig.display"
      >
        <el-tag
          v-for="(item, index) in defaultValue"
          @click.stop
          @close="closeTag(index)"
          size="small"
          closable
          type="info"
          :key="index"
        >
          {{ item[echoName] }}
        </el-tag>
        <p style="color: #ccc" v-if="!defaultValue.length">
          {{ item.placeholder }}
        </p>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-input
        v-model="project.projectName"
        readonly
        :placeholder="item.placeholder"
        suffix-icon="el-icon-caret-bottom"
        @focus="handleFocus"
        v-else
      ></el-input>
    </template>
    <div v-else>
      {{ getTextContent }}
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      append-to-body
      :width="dialogWidth"
      center
      custom-class="dialog_select"
      v-if="dialogVisible"
      :before-close="handleClose"
    >
      <div class="dialog_select_header">
        <div class="search">
          <slot name="search">
            <el-input
              v-model="searchConfig.value"
              :placeholder="searchConfig.placeholder"
            ></el-input>
          </slot>
          <span class="buttonBox" v-if="buttonFlag">
            <sr-popover content="搜索">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                circle
                @click="search"
              ></el-button>
            </sr-popover>
            <sr-popover content="重置">
              <el-button
                size="small"
                icon="el-icon-refresh"
                circle
                @click="refresh"
              ></el-button>
            </sr-popover>
          </span>
        </div>
      </div>
      <SrTable
        :data="table.data"
        :config="table.tableConfig"
        :page="table.page"
        ref="SrTable"
        @pageChanged="pageChanged"
        @clickRow="clickRow"
        @rowDblclick="rowDblclick"
        @selected="select"
        @selectAll="selectAll"
        @emptyClick="emptyClick"
      >
        <slot
          slot="leftBottomSlot"
          v-if="permission_btns.includes('M002_003_001') && addFlag"
        >
          没找到项目？去<el-button type="text" @click="emptyClick"
            >新增</el-button
          >
        </slot>
      </SrTable>
      <div slot="footer" class="dialog-footer" v-if="footerFlag">
        <el-button size="small" round type="primary" @click="confirm"
          >确定</el-button
        >
        <el-button size="small" round @click="close">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SrDialogSelect",
  props: {
    // 新增单个数据
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
    // 多选主键id
    rowKey: {
      type: [String, Number],
      default() {
        return "id";
      },
    },
    // 是否展示新增项目入口
    addFlag: {
      type: Boolean,
      default() {
        return true;
      },
    },
    // 弹框搜索和重置按钮是否显示
    buttonFlag: {
      type: Boolean,
      default() {
        return true;
      },
    },
    // 弹框底部按钮是否显示
    footerFlag: {
      type: Boolean,
      default() {
        return true;
      },
    },
    dialogTitle: {
      type: String,
      default: "选择项目",
    },
    dialogWidth: {
      type: String,
      default: () => {
        return "800px";
      },
    },
    getList: {
      type: Function,
      default: () => {
        return function () {};
      },
    },
    // 如果是多选情况选中之后需要将数据中的某个字段拼接起来显示，该字段用这个来接收
    echoName: {
      type: String,
      default: () => {
        return "projectName";
      },
    },
    // 不固定的请求接口的参数
    params: Object,
    hasChildrenFlag: {
      type: Boolean,
      default() {
        return true;
      },
    },
    tableConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 多选时再次打开弹框已经选中的数据
    selectData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 多选最多可选几个
    max: {
      type: Number,
      default: () => {
        return 20;
      },
    },
    header: {
      type: Array,
      default: () => {
        return [
          {
            label: "项目名称",
            prop: "projectName",
          },
          {
            label: "项目编号",
            prop: "projectCode",
          },
        ];
      },
    },
    isExpert: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    selectionConfig: {
      type: Object,
      default: () => {
        return {
          display: false,
        };
      },
    },
    // 搜索自定义传参
    searchConfig: {
      type: Object,
      default: () => {
        return {
          key: "keyword",
          placeholder: "请输入关键词",
          value: "",
        };
      },
    },
    isSuccess: {
      type: Function,
      default: (res) => {
        return function (res) {
          return res.code == 1000;
        };
      },
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
    projectName: {
      type: String,
      default: "",
    },
  },
  computed: {
    permission_btns: function () {
      return JSON.parse(sessionStorage.getItem("permission_btns") || "[]").map(
        (res) => {
          return res.permissionCode;
        }
      );
    },
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || "" === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
    getTextContent() {
      let content = "";
      if (this.table.tableConfig.selectionConfig.display) {
        if (
          Object.prototype.toString.call(this.defaultValue) === "[object Array]"
        ) {
          if (this.defaultValue && this.defaultValue.length > 0) {
            this.defaultValue.map((valItem, valIndex) => {
              if (valIndex == 0) {
                content += valItem[this.echoName];
              } else {
                content += ", " + valItem[this.echoName];
              }
            });
          }
        }
      } else {
        content = this.project.projectName;
      }
      return content;
    },
  },
  watch: {
    selectData: {
      handler: function (val) {
        this.defaultValue = val;
      },
      immediate: true,
    },
    item: {
      handler: function (val) {
        this.project.projectName = this.item.projectName;
      },
      immediate: true,
    },
    selectionConfig: {
      handler: function (val) {
        // console.log("赋值",val);
        this.table.tableConfig.selectionConfig = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      project: {
        projectName: null,
        projectCode: null,
        projectId: null,
      },
      keyword: null,
      table: {
        data: [],
        tableConfig: {
          load: this.load,
          highlightCurrentRow: true,
          selectionConfig: this.selectionConfig,
          header: this.header,
          rowKey: this.rowKey,
          indexConfig: {
            display: true,
            label: "序列",
            width: "52",
          },
          emptyConfig: {
            emptyTip: "没有搜索到项目？前往项目库进行项目",
            emptyBtn: "创建",
          },
        },
        page: {
          // 分页配置
          total: 0, //总条数
          pages: 0, //总页数
          pageSize: 5, //每页展示多少个
          pageNum: 1, //当前页
          minSize: 5,
          pageSizes: [5, 10, 20, 30],
          layout: "prev, pager, next, jumper",
        },
      },
      selectObj: [],
      defaultValue: [],
    };
  },
  mounted() {
    if (this.table.tableConfig.selectionConfig.display) {
      this.defaultValue = this.selectData;
    } else {
      this.project.projectName = this.projectName;
    }
    if (!this.permission_btns.includes("M002_003_001") || !this.addFlag) {
      this.table.tableConfig.emptyConfig = {
        emptyTip: "暂无内容",
      };
    }
    Object.keys(this.tableConfig).forEach((item) => {
      this.$set(this.table.tableConfig, item, this.tableConfig[item]);
    });
  },
  methods: {
    close() {
      this.keyword = null;
      this.searchConfig.value = "";
      this.$emit("close", "");
      this.dialogVisible = false;
    },
    handleClose(done) {
      this.keyword = null;
      this.searchConfig.value = "";
      this.$emit("close", "");
      done();
    },
    load(tree, treeNode, resolve) {
      let params = {
        pageNum: 1,
        pageSize: 999,
        isSubproject: 1,
        mainProjectId: tree.id,
      };
      this.getList(params).then((res) => {
        if (this.isSuccess(res)) {
          resolve(res.data.records);
        }
      });
    },
    search() {
      this.table.page.pageNum = 1;
      this.queryList();
    },
    // 点击按钮重置
    refresh() {
      this.keyword = null;
      this.searchConfig.value = "";
      this.table.page.pageNum = 1;
      this.$emit("refresh");
      this.queryList();
    },
    // 输入框获得焦点之后打开dialog弹框
    handleFocus() {
      this.dialogVisible = true;
      if (this.table.tableConfig.selectionConfig.display) {
        this.selectObj = this.selectData;
      } else {
        this.selectObj = [];
      }
      this.defaultValue = this.selectData;
      this.queryList();
    },
    // 点击单行事件
    clickRow(val) {
      if (!this.table.tableConfig.selectionConfig.display) {
        this.selectObj = val;
      }
    },
    // 单行双击事件
    rowDblclick(val) {
      console.log("单行双击事件", val);
      if (!this.table.tableConfig.selectionConfig.display) {
        this.selectObj = val;
        this.confirm();
      }
    },
    //页数发生改变
    pageChanged(val) {
      this.table.page.pageNum = val;
      this.$emit("select", this.selectObj);
      this.queryList();
    },
    // 搜索条件查询事件
    queryList() {
      this.$emit("queryList");
      let params = {
        pageNum: this.table.page.pageNum,
        pageSize: 5, //this.isExpert ? 999 : 10,
        [this.searchConfig.key]: this.searchConfig.value,
        ...this.params,
      };
      this.getList(params).then((res) => {
        if (this.isSuccess(res)) {
          if (res.data.records) {
            this.table.data = res.data.records.map((item) => {
              if (!this.hasChildrenFlag) {
                item.hasChildren = false;
              }
              return item;
            });
          } else {
            this.table.data = res.data.list;
          }
          console.log("res.data.total", res.data.total);
          this.table.page.total = res.data.total;
          if (
            this.table.tableConfig.selectionConfig.display &&
            this.selectData.length > 0
          ) {
            this.$refs.SrTable.toggleRowSelection(this.selectData);
          }
        }
      });
    },
    // 确认选中
    confirm() {
      if (this.table.tableConfig.selectionConfig.display) {
        // 多选
        if (this.selectObj) {
          let projectName = this.selectObj.map((res) => {
            return res[this.echoName];
          });
          this.project.projectName = projectName.join(",");
          this.defaultValue = this.selectObj;
          console.log("多选", this.defaultValue);
          this.$emit("select", this.selectObj);
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
        }
      } else {
        // 单选
        this.project = this.selectObj;
        if (this.searchConfig.name) {
          this.project.projectName = this.project[this.searchConfig.name];
        }
        this.$emit("select", this.selectObj);
        this.dialogVisible = false;
      }
      this.keyword = null;
      this.searchConfig.value = "";
    },
    closeTag(val) {
      this.defaultValue = this.defaultValue.filter((item, index) => {
        return val != index;
      });
      this.$emit("select", this.defaultValue);
    },

    // 开启多选框之后的选择事件
    select(val) {
      // this.selectObj = this.defaultValue.concat(val);
      let rowKey = "id";
      if (
        this.table &&
        this.table.tableConfig &&
        this.table.tableConfig.rowKey
      ) {
        rowKey = this.table.tableConfig.rowKey;
      }
      let selectedArr = [];
      if (val && val.length > 0) {
        val.map((item) => {
          let temp = selectedArr.filter(
            (selectedItem) => selectedItem[rowKey] == item[rowKey]
          );
          if (temp.length == 0) {
            selectedArr.push(item);
          }
        });
      }
      // console.log('select----', val)
      // console.log('select----', selectedArr)
      this.selectObj = selectedArr;
    },
    selectAll(val) {
      // this.selectObj = this.defaultValue.concat(val);
      this.selectObj = val;
    },
    emptyClick() {
      window.history.pushState({}, "", "/subplan/#/projectLibraryAdd");
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrDialogSelect/index.vue